var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report m-3"},[_c('div',{staticClass:"heading headtext"},[_c('span',[_vm._v("Candidate Report for '"+_vm._s(_vm.candidateDetails.name)+"'")])]),_c('div',[_c('b-row',{staticClass:"candidate-details"},[_c('b-col',{attrs:{"xl":"8","lg":"8","sm":"12"}},[_c('b-row',{staticClass:"candidatereport-first-subcontainer"},[_c('b-col',{staticClass:"ml-3",attrs:{"xl":"9","lg":"9","sm":"6"}},[_c('div',{staticClass:"candidatereport-details"},[_c('div',{staticClass:"d-flex flex-column mb-2"},[_c('span',{staticClass:"pd-card-middle-head"},[_vm._v("Name")]),_c('span',{staticClass:"candidatereport-subheadings"},[_vm._v(_vm._s(_vm.candidateDetails.name))])]),_c('div',{staticClass:"d-flex flex-column mb-2"},[_c('span',{staticClass:"pd-card-middle-head"},[_vm._v("Email")]),_c('span',{staticClass:"candidatereport-subheadings"},[_vm._v(_vm._s(_vm.candidateDetails.emailID))])])]),_c('b-button',[_vm._v(" View Answers ")])],1),_c('b-col',{staticClass:"view-answers",attrs:{"xl":"2","lg":"2","sm":"6"}},[_c('img',{attrs:{"src":require("../../../assets/report_candidate.svg"),"alt":"Illustration of a boy sitting"}})])],1),_c('b-row',{staticClass:"candidatereport-first-subcontainer"},[_c('b-col',[_c('span',{staticClass:"candidatereport-card-header"},[_vm._v("Candidate strengths and weaknesses")]),_c('hr',{staticClass:"w-100"}),_c('b-row',{staticClass:"candidate-sw"},[_c('b-col',{staticClass:"bg-card px-0",attrs:{"cols":"5"}},[_c('h6',{staticClass:"card-header"},[_vm._v("Strengths")]),_c('div',{staticClass:"list-container"},[_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")])])]),_c('b-col',{staticClass:"bg-card px-0",attrs:{"cols":"5"}},[_c('h6',{staticClass:"card-header"},[_vm._v("Areas of Development")]),_c('div',{staticClass:"list-container"},[_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Aod1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")]),_c('div',{staticClass:"list",style:({
											borderLeft:
												'solid 5px #' +
												Math.random()
													.toString(16)
													.substr(-6),
										})},[_vm._v(" Strength1 ")])])])],1)],1)],1)],1),_c('b-col',{staticClass:"candidatereport-first-subcontainer"},[_c('h4',[_vm._v("Overview")]),_c('OverviewCharts')],1)],1),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"report__card bar-chart-container"},[_c('CompoundBars',{attrs:{"subject":"difficulty","title":"Competence graph (Difficulty)"}})],1),_c('div',{staticClass:"report__card bar-chart-container"},[_c('CompoundBars',{attrs:{"subject":"section","title":"Competence graph (Sections)"}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }